// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CA_OPEN_REVIEW_COST_MODEL,
} from './constants';

export function openReviewCostModel(ca, ca_name) {
  return {
    type: CA_OPEN_REVIEW_COST_MODEL,
    caSelected:ca,
    ca_name:ca_name
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CA_OPEN_REVIEW_COST_MODEL:
      return {
        ...state,
        openReviewCostModelDialog:true,
        caSelected:action.caSelected,
        ca_name:action.ca_name
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/openReviewCostModel.js